export default __webpack_public_path__ + "38f7e9ffc7b9e50090785b0836e49ba3.png";